<template>
  <div>
    <div class="topo-container" ref="topoContainer"></div>

    <div class="legend-container">
      <ul>
        <li v-for="(node, index) in nodeData" :key="node.id" class="legend-item">
          <div
              class="legend-color-box"
              :style="getColorForTagSpan(node.color_tag)"
          ></div>
          <span>{{ node.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>



<script>
import * as BABYLON from "babylonjs";
import "babylonjs-loaders";

export default {
  name: "topo",
  data() {
    return {
      nodeData: [
        { id: 1, name: "漏洞", color_tag: 1 },
        { id: 2, name: "攻击技术", color_tag: 2 },
        { id: 3, name: "论文", color_tag: 4 },
        { id: 4, name: "论文", color_tag: 4 },
        { id: 5, name: "论文", color_tag: 4 }
      ],
      canvas: null,
      engine: null,
      scene: null,
      spheres: [],
      links: [],
      dragging: false,
      selectedSphere: null,
      previousPosition: new BABYLON.Vector3(0, 0, 0),
      offset: new BABYLON.Vector3(0, 0, 0)
    };
  },
  mounted() {
    this.initBabylon();
    this.createScene();
    this.animate();
    this.resizeCanvas();
  },
  methods: {
    initBabylon() {
      this.canvas = document.createElement("canvas");
      this.$refs.topoContainer.appendChild(this.canvas);
      this.engine = new BABYLON.Engine(this.canvas, true);
      this.engine.clearColor = new BABYLON.Color4(0, 0, 0, 0);

      this.scene = new BABYLON.Scene(this.engine);
      const camera = new BABYLON.ArcRotateCamera(
        "camera",
        Math.PI / 2,
        Math.PI / 2,
        50,
        BABYLON.Vector3.Zero(),
        this.scene
      );

      camera.attachControl(this.canvas, true);
      camera.lowerAlphaLimit = -Math.PI;
      camera.upperAlphaLimit = Math.PI;

      const light = new BABYLON.HemisphericLight("light", BABYLON.Vector3.Up(), this.scene);

      light.intensity = 0.7;
    },

    createScene() {
      const nodeData = this.nodeData; // 使用组件中的节点数据

      this.scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
      const linkData = [
        { start_id: 1, end_id: 2, relation: "uses" },
        { start_id: 3, end_id: 1, relation: "measure" },
        { start_id: 3, end_id: 2, relation: "measure" }
      ];

      const minDistance = 10; // 设置球体之间的最小距离

      nodeData.forEach((node) => {
        let sphere;

        let positionFound = false;

        while (!positionFound) {
          // 随机生成位置
          const randomPosition = new BABYLON.Vector3(
            (Math.random() * 40 - 20),
            (Math.random() * 40 - 20),
            (Math.random() * 40 - 20)
          );

          // 检查与已有球体的距离
          const isTooClose = this.spheres.some(existingSphere => {
            const distance = BABYLON.Vector3.Distance(existingSphere.position, randomPosition);

            return distance < minDistance;
          });

          if (!isTooClose) {
            positionFound = true;
            sphere = BABYLON.MeshBuilder.CreateSphere(`sphere-${node.id}`, { diameter: 5 }, this.scene);
            const color = this.getColorForTag(node.color_tag);

            sphere.material = new BABYLON.StandardMaterial(`material-${node.id}`, this.scene);
            sphere.material.diffuseColor = color;
            sphere.position = randomPosition;

            sphere.userData = { id: node.id, name: node.name };
            this.spheres.push(sphere);

            sphere.actionManager = new BABYLON.ActionManager(this.scene);
            sphere.actionManager.registerAction(new BABYLON.ExecuteCodeAction(
              BABYLON.ActionManager.OnPickTrigger,  // 事件类型：点击
              (evt) => {
                console.log(`Clicked on node with ID: ${node.id}`);
              }
            ));
          }
        }
      });

      // 生成连接线
      linkData.forEach((link) => {
        const startSphere = this.spheres.find(s => s.userData.id === link.start_id);
        const endSphere = this.spheres.find(s => s.userData.id === link.end_id);

        if (startSphere && endSphere) {
          const line = BABYLON.MeshBuilder.CreateLines(
            `line-${link.start_id}-${link.end_id}`,
            {
              points: [startSphere.position, endSphere.position],
              color: new BABYLON.Color3(1, 1, 1)
            },
            this.scene
          );

          this.links.push(line);
        }
      });
    },
    getColorForTag(tag) {
      const colors = {
        1: new BABYLON.Color3(1, 0, 0),
        2: new BABYLON.Color3(0, 1, 0),
        4: new BABYLON.Color3(0, 0, 1)
      };

      return colors[tag] || new BABYLON.Color3(0.5, 0.5, 0.5); // 默认灰色
    },
    getColorForTagSpan(tag) {
      const colors = {
        1: new BABYLON.Color3(1, 0, 0),
        2: new BABYLON.Color3(0, 1, 0),
        4: new BABYLON.Color3(0, 0, 1)
      };
      const color = colors[tag] || new BABYLON.Color3(0.5, 0.5, 0.5);

      return {
        backgroundColor: `rgb(${Math.floor(color.r * 255)}, ${Math.floor(color.g * 255)}, ${Math.floor(color.b * 255)})`
      };
    },


    animate() {
      this.engine.runRenderLoop(() => {
        this.scene.render();
      });
    },

    resizeCanvas() {
      const width = this.$refs.topoContainer.clientWidth;
      const height = this.$refs.topoContainer.clientHeight;

      this.canvas.width = width;
      this.canvas.height = height;
      this.engine.resize();
    }
  },
  watch: {
    "$refs.topoContainer": {
      handler() {
        this.resizeCanvas();
      },
      immediate: true
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onMouseMove);
    window.removeEventListener("mouseup", this.onMouseUp);
  }
};
</script>

<style scoped lang="less">
.topo-container {
  position: absolute;
  top: 80px;
  left: 15px;
  width: 520px;
  height: 521px;
  overflow: hidden;
  background-color: transparent;
}

.legend-container {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 10px;
  border-radius: 5px;
  color: white;
  max-width: 200px;
  z-index: 10;
}

.legend-container ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.legend-color-box {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  border-radius: 2px; /* 可选的圆角样式 */
}

.legend-container span {
  font-size: 14px;
}
</style>
